<ion-card class="ion-no-margin mar8 card-white-background-color">
  <ion-row
    class="ion-text-center fs-3 card-flight"
    (click)="navigateToDetail(flight)"
  >
    <ion-col size="3">
      <ion-label class="fs-2 font600 card-primary-text-color">{{
        flight?.flightid
      }}</ion-label>
    </ion-col>
    <ion-col size="3">
      <ion-label class="fs-2 font600 card-primary-text-color">{{
        flight?.originCity
      }}</ion-label>
    </ion-col>
    <ion-col size="3">
      <ion-label class="fs-2 font600 card-primary-text-color">{{
        flight?.destCity
      }}</ion-label>
    </ion-col>

    <ion-col size="3" class="d-flex flex-col ion-justify-content-center ion-align-items-center">
      <ion-label class="fs-2 font600 card-primary-text-color">{{
        flight?.startdate
      }}</ion-label>
      <ion-label
        *ngIf="flight?.IsTracking"
        class="fs-2 font600 card-green-text-color"
      >
      {{"trips.calender_flights.tracking" | translate}}
      </ion-label>
    </ion-col>
  </ion-row>
</ion-card>
